;(function ($, YI) {YI.commerceApartment = function () {

    // передаём id квартиры через параметр "id" в адресной строке
    var id = Number(locationParams('id'));
    if (!id) history.back();

    // подгружаем информацию о квартире
    var flat = yc('v2/dwellings/flats/' + id);
    if (!flat) history.back();

    // аксимальная высота изображения
    var imageMaxHeight = $(window).height() - $('#headBlock').height() - $('.footer-outer').height() - 65;

    // планировка
    $('#commerce_image').attr('src', flat.images[0]).css('max-height', imageMaxHeight);

    // площадь
    $('#commerce_area').text(flat.total_area);

    // назачение
    if (flat.comments) $('#commerce_desc').html(flat.comments).parent().show();

    // расположение входа
    if (flat.house_name) {
        var entry_position = null;
        switch (flat.house_name) {
            case '9/1':
                entry_position = 'с улицы Пекинская';
                break;
            case '9/2':
            case '8':
                entry_position = 'со двора';
                break;
        }
        if (entry_position) $('#commerce_entry_position').text(entry_position).parent().show();
    }

    // ремонт
    if (flat.finishing) {
        var finishing = null;
        switch (flat.finishing) {
            case 'rough':
                finishing = 'черновая отделка';
                break;
            case 'halfclean':
                finishing = 'получистовая отделка';
                break;
            case 'clean':
                finishing = 'чистовая отделка';
                break;
            case 'with':
                finishing = 'с отделкой';
                break;
            case 'design':
                finishing = 'дизайнерский';
                break;
        }
        if (finishing) $('#commerce_finishing').text(finishing).parent().show();
    }

    // подгружаем информацию этажа
    var storey = yc('v2/dwellings/storeys/' + flat.storey);
    var polygon = '', width = '', height = '';
    width = storey.image_maps[0].width;
    height = storey.image_maps[0].height;
    $.each(storey.image_maps[0].flats, function (i, item) {
        if (item.id === flat.id) {
            polygon = item.polygon;
        }
    });

    // ссылка на pdf
    var pdf_url = {
        plan: flat.images[0],
        liter: flat.house_name,
        area: flat.total_area,
        planstorey_img: storey.image_maps[0].path,
        planstorey_poligon: polygon,
        planstorey_w: width,
        planstorey_h: height
    };
    pdf_url = 'https://chernikadom.ru/pdf-maker/?' + Object.keys(pdf_url).map(function(key) {
        return key + '=' + pdf_url[key]
    }).join('&').replace(/ /g,'%20');
    $('#commerce_pdf').click(function () {
        window.open(pdf_url);
    });

}})(jQuery, window.yesidea || (window.yesidea = {}));